import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import './Cart.less';
import Item, { ItemShape } from './Item';

const LOCALE_PREFIX = 'components/Cart/cart';

export const CART_THEMES = {
    WHITE: 'theme-white',
    DEFAULT: ''
};

export class Cart extends Component {

    static propTypes = {
        intl: intlShape.isRequired,
        cart: PropTypes.shape(CartShape).isRequired,
        merchantName: PropTypes.string.isRequired,
        theme: PropTypes.oneOf(Object.values(CART_THEMES))
    };

    static defaultProps = {
        theme: CART_THEMES.DEFAULT
    };

    constructor(props) {
        super(props);
        this.state = {
            showResults: false
        };
    }

    toggleContent = (event) => {
        event.preventDefault();
        this.setState({ showResults: !this.state.showResults });
    };


    listItems = (cart, intl) => {
        const items = cart.items;

        const listItems = items && items.map((item) => {
            if (item.quantity >= 1) {
                return (
                    <Item key={item.id} item={item} />
                );
            }
        });

        return (
            <ul className="cue-cart-items" role="menu" aria-labelledby="dLabel">
                {listItems}
                <li className="cue-cart-item cue-item-subtotal">
                    <span className="cue-cart-item-description pull-left">
                        <FormattedMessage id={`${LOCALE_PREFIX}.cartItemTotal`} />
                    </span>
                    <div className="pull-right">
                        <span className="cue-cart-item-amount">{cart.format_subtotal}</span>
                    </div>
                </li>
                <li className="cue-cart-item cue-item-tax">
                    <span className="cue-cart-item-description pull-left">
                        <FormattedMessage id={`${LOCALE_PREFIX}.cartTax`} />
                    </span>
                    <div className="pull-right">
                        <span className="cue-cart-item-amount">{cart.format_tax}</span>
                    </div>
                </li>
                <li className="cue-cart-item cue-item-shipping">
                    <span className="cue-cart-item-description pull-left">
                        <FormattedMessage id={`${LOCALE_PREFIX}.cartShipping`} />
                    </span>
                    <div className="pull-right">
                        <span className="cue-cart-item-amount">{cart.format_shipping}</span>
                    </div>
                </li>
                <li className="cue-cart-item cue-cart-total">
                    <span className="cue-cart-item-description pull-left">
                        <FormattedMessage id={`${LOCALE_PREFIX}.cartTotal`} />
                    </span>
                    <div className="pull-right">
                        <span className="cue-cart-item-amount">{cart.gross_total_amount.format}</span>
                    </div>
                </li>
                <div className="clearfix" />
            </ul>
        );
    };

    render() {
        const { intl, cart, merchantName, theme } = this.props;

        return (
            <div className="Cart">
                <div className={theme}>
                    <div className="dropdown">
                        <a href="#!"
                            data-automation-id="cart"
                            className="dropdown-toggle"
                            name="dropdown-toggle"
                            onClick={this.toggleContent}
                        >
                            <span className="cue-cart-icon" />
                            <span className="cue-cart-value">{cart.gross_total_amount.format}</span>
                            <span className="cue-cart-toggle" />
                        </a>
                        <div className="clearfix" />
                    </div>
                    {this.state.showResults && (
                        <div className="cart-menu">
                            <div className="cue-cart-header">
                                <div className="cue-cart-description pull-left">
                                    <strong>{merchantName}</strong>
                                </div>
                                <input tabIndex="0" type="button" aria-label="close-cart-button"
                                    className="cue-cart-close pull-right" onClick={this.toggleContent}
                                />
                            </div>
                            {this.listItems(cart, intl)}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export const CartShape = {
    format_shipping: PropTypes.string.isRequired,
    format_subtotal: PropTypes.string.isRequired,
    format_tax: PropTypes.string.isRequired,
    gross_total_amount: PropTypes.shape({
        format: PropTypes.string.isRequired
    }).isRequired,
    items: PropTypes.arrayOf(ItemShape).isRequired
};

export const mapStateToProps = state => ({
    cart: state.serverData.cart,
    merchantName: state.serverData.merchantName
});

export default connect(mapStateToProps)(injectIntl(Cart));
